export function checkPermission(Rights, action) {
  debugger;
  if (action === "Add" && Rights.value.Create === true) {
    return {
      hasPermission: true,
      toast: null,
    };
  } else if (action === "Edit" && Rights.value.Update === true) {
    return {
      hasPermission: true,
      toast: null,
    };
  } else if (action === "Read" && Rights.value.Read === true) {
    return {
      hasPermission: true,
      toast: null,
    };
  } else if (action === "Delete" && Rights.value.Delete === true) {
    return {
      hasPermission: true,
      toast: null,
    };
  } else {
    return {
      hasPermission: false,
      toast: {
        severity: "warn",
        summary:
          "You do not have permission to access. Please contact your administrator for assistance.",
        detail: "",
        life: 3000,
      },
    };
  }
}
